// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"UM-z","loadingMedia":"VM-z","reviewsImagesAndVideos":"WM-z","limitHeight":"XM-z"};